import {
    REQUEST_PAYPAL_DETAILS,
    SUCCESS_PAYPAL_DETAILS,
    FAILURE_PAYPAL_DETAILS
} from './constants';
import { HTTP_METHOD_GET } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';

export const fetchPaypalDetails = orderId => {
    return {
        [CALL_API]: {
            endpoint: `/payment-solution/paypal/${orderId}/details`,
            types: [REQUEST_PAYPAL_DETAILS, SUCCESS_PAYPAL_DETAILS, FAILURE_PAYPAL_DETAILS],
            method: HTTP_METHOD_GET
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/paypal/actions.js